export const appendScriptClientSide = (src: string) => {
    if (typeof window === 'undefined') {
        return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
};
